module.exports = __webpack_public_path__ + "img/category-icon.750ce4ba.png";